import { AppointmentDateCard } from 'components/AppointmentDate';
import { Button } from 'components/Button';
import { Heading } from 'components/Typography';
import { ScheduleContextV3, withScheduleMachineStateV3 } from 'domains/signupv3/schedule/context';
import { useTranslation } from 'react-i18next';

const ConfirmConsultationDate: React.FC = () => {
  const consultationDate = ScheduleContextV3.useSelector(({ context }) => context.data.consultationDate);
  const { send } = ScheduleContextV3.useActorRef();

  const isScheduling = ScheduleContextV3.useSelector(state => state.matches('schedulingConsultation'));

  const { t } = useTranslation();

  return (
    <>
      <Heading level="h2" className="mb-16">
        {t(`consultation.schedule.confirm.title`)}
      </Heading>

      <Heading level="h7" className="mb-64 sm-d:mb-40">
        {t(`consultation.schedule.confirm.subtitle`)}
      </Heading>

      <AppointmentDateCard
        date={consultationDate as Date}
        className="mb-64 sm-d:mb-40"
        onEdit={() => send({ type: 'back' })}
        appointmentTitle={t('consultation.schedule.confirm.consultationName')}
      />

      <div className="flex sm-d:flex-col gap-16">
        <Button
          data-testid="consultation-date-submit-button"
          size="lg"
          className="sm-d:w-full"
          autoFocus
          onClick={() =>
            send({
              type: 'confirmedConsultationDate',
            })
          }
          loading={isScheduling}
        >
          {t('consultation.schedule.confirm.submit')}
        </Button>
        <Button disabled={isScheduling} size="lg" onClick={() => send({ type: 'back' })} variant="ghost">
          {t('consultation.schedule.confirm.back')}
        </Button>
      </div>
    </>
  );
};

export const ScheduleV3ConfirmConsultationDate = withScheduleMachineStateV3(ConfirmConsultationDate, [
  'confirmConsultationDate',
  'schedulingConsultation',
]);
